import React, { FunctionComponent } from "react";
import { useTheme, IconButton as MuiIconButton } from "@mui/material";
import { Theme } from "@emotion/react";

interface IconButtonProps {
    height: number;
    width: number;
    onClick: () => void;
    hiddenText: string;
    disabled?: boolean;
    className?: string;
    children?: React.ReactNode;
    dataTestId?: string;
}

export const IconButtonComponent: FunctionComponent<IconButtonProps> = ({ children, dataTestId, height, width, onClick, hiddenText, disabled, className }) => {
    const theme = useTheme<Theme>();
    const style: React.CSSProperties = {
        backgroundColor: `${disabled ? theme.shades.three : theme.primaryColors.focusAccent}`,
        borderRadius: "50%",
        padding: "20px",
        height: `${height}px`,
        width: `${width}px`,
    };

    return (
        <MuiIconButton className={className} color="primary" data-testid={dataTestId} data-cy={dataTestId} style={style} onClick={onClick} disabled={disabled}>
            {children}
            <span
                style={{
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    height: "1px",
                    margin: "-1px",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap",
                }}
            >
                {hiddenText}
            </span>
        </MuiIconButton>
    );
};

export default IconButtonComponent;
